import { Controller } from '@hotwired/stimulus'

export default class AutosaveController extends Controller {
  static values = {
    autosaveIntervalSeconds: { type: Number, default: 2 }
  }

  #saveTimerId = null

  connect() {
    this.element.addEventListener('input', this.onItemChange)
    this.element.addEventListener('lexxy:change', this.onItemChange)
    this.element.addEventListener('blur', this.performSave)
    this.element.addEventListener('lexxy:blur', this.performSave)
  }

  disconnect() {
    this.element.removeEventListener('input', this.onItemChange)
    this.element.removeEventListener('lexxy:blur', this.onItemChange)
    this.element.removeEventListener('blur', this.performSave)
    this.element.removeEventListener('lexxy:blur', this.performSave)
  }

  onItemChange = () => {
    if (this.#saveTimerId) return

    this.element.classList.add('unsaved-changes')
    this.#saveTimerId = setTimeout(this.performSave, this.autosaveIntervalSecondsValue * 1000)
  }

  performSave = async () => {
    clearTimeout(this.#saveTimerId)
    this.#saveTimerId = null
    const formData = new FormData(this.element)
    const method = formData.get('_method') || this.element.method
    formData.delete('_method')

    const response = await fetch(this.element.action, {
      method,
      body: formData,
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })

    this.element.classList.remove('unsaved-changes')
    if (response.ok) {
      this.element.classList.remove('save-error')
    } else {
      this.element.classList.add('save-error')
    }
  }
}
